import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/config";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// 페이지 import
import Onboarding from "./pages/onboarding/Onboarding";
import onboardingQuestions from "./data/onboardingQuestions.json";
import { Question } from "./types/onboarding";
import Check from "./pages/Check";
import Learn from "./pages/Learn";
import Reserve from "./pages/Reserve";
import StrokeCheck from "./pages/StrokeCheck";
import StrokeCheckNew from "./pages/stroke/StrokeCheckNew";
import StrokeCheckResults from "./pages/stroke/StrokeCheckResults";
import CognitiveCheck from "./pages/CognitiveCheck";
import CognitiveCheckNew from "./pages/cognitive/CognitiveCheckNew";
import CognitiveCheckResults from "./pages/cognitive/CognitiveCheckResults";
import DigitSpan from "./pages/cognitive/DigitSpan";
import RandomCube from "./pages/cognitive/RandomCube";
import TowerOfLondon from "./pages/cognitive/TowerOfLondon";
import VerbalLearning from './pages/cognitive/VerbalLearning';
import HeadacheCheck from "./pages/HeadacheCheck";
import HeadacheCheckNew from "./pages/headache/HeadacheCheckNew";
import HeadacheCheckResults from "./pages/headache/HeadacheCheckResults";
import MyInformation from './pages/MyInformation';
import NeckSoundCheck from './pages/NeckSoundCheck';
import NeckSoundCheckNew from './pages/necksound/NeckSoundCheckNew';
import StrokeReport from "./pages/stroke/StrokeReport";
import HeadacheReport from './pages/headache/HeadacheReport';
import CognitiveReport from './pages/cognitive/CognitiveReport';
import HospitalLayout from "./components/Hospital/HospitalLayout";
import Login from "./pages/Login";

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: "#2196f3" },
    secondary: { main: "#f50057" },
  },
});

const App: React.FC = () => {
  return (
    <Router>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          
          <Routes>
            <Route path="/" element={<HospitalLayout />}>
              <Route index element={<Onboarding questions={onboardingQuestions.questions as Question[]} />} />

              <Route path="login" element={<Login />} />
              <Route path="check" element={<Check />} />
              <Route path="learn" element={<Learn />} />
              <Route path="reserve" element={<Reserve />} />
              <Route path="my-info" element={<MyInformation />} />

              {/* 뇌졸중 */}
              <Route path="stroke_check" element={<StrokeCheck />} />
              <Route path="stroke/check/new" element={<StrokeCheckNew />} />
              <Route path="stroke/check/results" element={<StrokeCheckResults />} />
              <Route path="stroke/check/results/:id" element={<StrokeCheckResults />} />
              <Route path="stroke/report/:id" element={<StrokeReport />} />

              {/* 인지 */}
              <Route path="cognitive_check" element={<CognitiveCheck />} />
              <Route path="cognitive/check/new" element={<CognitiveCheckNew />} />
              <Route path="cognitive/check/results" element={<CognitiveCheckResults />} />
              <Route path="cognitive/check/results/:testSetId" element={<CognitiveCheckResults />} />
              <Route path="cognitive/report/:id" element={<CognitiveReport />} />
              <Route path="cognitive/DigitSpan" element={<DigitSpan />} />
              <Route path="cognitive/RandomCube" element={<RandomCube />} />
              <Route path="cognitive/VerbalLearning" element={<VerbalLearning />} />
              <Route path="cognitive/TowerOfLondon" element={<TowerOfLondon />} />

              {/* 두통 */}
              <Route path="headache_check" element={<HeadacheCheck />} />
              <Route path="headache/check/new" element={<HeadacheCheckNew />} />
              <Route path="headache/check/results" element={<HeadacheCheckResults />} />
              <Route path="headache/report/:id" element={<HeadacheReport />} />

              {/* 경동맥 */}
              <Route path="necksound_check" element={<NeckSoundCheck />} />
              <Route path="necksound/check/new" element={<NeckSoundCheckNew />} />
            </Route>

            {/* 2. 병원 ID가 있는 모든 경로 */}
            <Route path="/:hospitalId" element={<HospitalLayout />}>
              
              {/* /:hospitalId/ (메인 온보딩) */}
              <Route index element={<Onboarding questions={onboardingQuestions.questions as Question[]} />} />

              {/* 기능 페이지들 (앞에 /:hospitalId가 자동으로 붙음) */}
              <Route path="login" element={<Login />} />
              <Route path="check" element={<Check />} />
              <Route path="learn" element={<Learn />} />
              <Route path="reserve" element={<Reserve />} />
              <Route path="my-info" element={<MyInformation />} />

              {/* 뇌졸중 관련 */}
              <Route path="stroke_check" element={<StrokeCheck />} />
              <Route path="stroke/check/new" element={<StrokeCheckNew />} />
              <Route path="stroke/check/results" element={<StrokeCheckResults />} />
              <Route path="stroke/check/results/:id" element={<StrokeCheckResults />} />
              <Route path="stroke/report/:id" element={<StrokeReport />} />

              {/* 인지 관련 */}
              <Route path="cognitive_check" element={<CognitiveCheck />} />
              <Route path="cognitive/check/new" element={<CognitiveCheckNew />} />
              <Route path="cognitive/check/results" element={<CognitiveCheckResults />} />
              <Route path="cognitive/check/results/:testSetId" element={<CognitiveCheckResults />} />
              <Route path="cognitive/report/:id" element={<CognitiveReport />} />
              <Route path="cognitive/DigitSpan" element={<DigitSpan />} />
              <Route path="cognitive/RandomCube" element={<RandomCube />} />
              <Route path="cognitive/VerbalLearning" element={<VerbalLearning />} />
              <Route path="cognitive/TowerOfLondon" element={<TowerOfLondon />} />

              {/* 두통 관련 */}
              <Route path="headache_check" element={<HeadacheCheck />} />
              <Route path="headache/check/new" element={<HeadacheCheckNew />} />
              <Route path="headache/check/results" element={<HeadacheCheckResults />} />
              <Route path="headache/report/:id" element={<HeadacheReport />} />

              {/* 경동맥 */}
              <Route path="necksound_check" element={<NeckSoundCheck />} />
              <Route path="necksound/check/new" element={<NeckSoundCheckNew />} />
              
            </Route>

          </Routes>
        </ThemeProvider>
      </I18nextProvider>
    </Router>
  );
};

export default App;